import { Entity, EntityMeta } from '@mainstage/catalog-model';

declare interface SystemPrototypeTypeEntity extends Entity {
  apiVersion: 'witboost.com/v2';
  kind: 'SystemPrototypeType';
  metadata: {
    name: string;
    displayName?: string;
  } & EntityMeta;
  spec: {
    evolvesInto: string;
    template?: string;
  };
}

export type { SystemPrototypeTypeEntity as SystemPrototypeType };

export type HeadlessSystemPrototype = SystemPrototypeTypeEntity & ProjectType;

export function isSystemPrototype(
  entity: Entity,
): entity is SystemPrototypeTypeEntity {
  return (
    entity.apiVersion === 'witboost.com/v2' && entity.kind === 'SystemPrototype'
  );
}

export function isSystemPrototypeType(
  entity: Entity,
): entity is SystemPrototypeTypeEntity {
  return (
    entity.apiVersion === 'witboost.com/v2' &&
    entity.kind === 'SystemPrototypeType'
  );
}
